<template>
  <div data-testid="site-templates-page">
    <div style="margin-bottom: 20px;">
      <Button
        :label="t('Adicionar template de e-mail')"
        icon="pi pi-plus"
        size="small"
        data-testid="site-templates-add-button"
        @click="handleNew"
      />
    </div>

    <site-templates-table
      ref="siteTemplatesTableRef"
      @edit="handleEdit">
    </site-templates-table>

    <!-- SiteTemplatesModal is centralized in ModalManager.vue - opened via eventBus -->
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import SiteTemplatesTable from './SiteTemplatesTable.vue';
import { eventBus } from '../../eventBus';
// SiteTemplatesModal is centralized in ModalManager.vue
import { log } from '../../utils/DebugLogger';

type TemplateId = number | string;

interface SiteTemplatesTableInstance {
  loadData: () => void | Promise<void>;
}

withDefaults(defineProps<{
  translations?: Record<string, unknown>;
}>(), {
  translations: () => ({})
});

const { t } = useI18n();

const siteTemplatesTableRef = ref<SiteTemplatesTableInstance | null>(null);

const loadData = async (): Promise<void> => {
  log('SiteTemplatesPage', 'loadData', 'Reloading data');
  if (siteTemplatesTableRef.value) {
    await siteTemplatesTableRef.value.loadData();
  }
};

const handleNew = (): void => {
  log('SiteTemplatesPage', 'handleNew', 'Opening modal for new template via eventBus');
  eventBus.emit('modal.site-templates.open', { action: 'create' });
};

const handleEdit = (templateId?: TemplateId): void => {
  log('SiteTemplatesPage', 'handleEdit', 'Editing template ID via eventBus', templateId);
  if (templateId === undefined) return;
  eventBus.emit('modal.site-templates.open', { id: templateId, action: 'edit' });
};

onMounted(() => {
  log('SiteTemplatesPage', 'mounted', 'Component mounted');
});

defineExpose({
  loadData,
  handleNew,
  handleEdit
});
</script>

<style scoped>
</style>
